import { FOBTRADING_MODULE_NAME } from "../index";

/** Módulo fobtrading_module (vista operación) activo en el tenant, según `activeModules` de localStorage. */
export function isFobtradingModuleActive() {
  try {
    const raw = localStorage.getItem("activeModules");
    if (!raw) return false;
    const modules = JSON.parse(raw);
    if (!Array.isArray(modules)) return false;
    return modules.some((m) => m && String(m.name || "") === FOBTRADING_MODULE_NAME);
  } catch (e) {
    return false;
  }
}
